import { AppService } from './../../app.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { RoutingService, RoutesEnum, AccountDataService, AccountSettingsDataService } from '../';
import { Account } from '../../models';
import { Observable } from 'rxjs';
import { AccountService } from '../config';
import { ThemeUtils } from '@primeuix/themes';

@Injectable()
export class AccountResolverService implements Resolve<any> {
    constructor(
        private accountDataService: AccountDataService,
        public appService: AppService,
        public accountService: AccountService,
        private accountSettingDataService: AccountSettingsDataService,
        public routingService: RoutingService) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<Account> {
        return new Promise(async (resolve, reject) => {
            const accountCode = route.params.accountCode;
            const versionNumber = route.params.versionNumber;

            const target = await this.accountService.getTargetAccount(accountCode, versionNumber, false);

            if (target === null) {
                this.appService.showMsg('error', 'Cannot find the requested account.');
                this.routingService.navigateToDefault();
                reject();
            }

            this.accountSettingDataService.activeAccount = target;
            resolve(target);
        });
    }
}
